/* Utility for getting the application/brand name: Venn or alternative name
 * Used to replace hardcoded Venn in hundreds of places */
import { getTextThemeProvider } from './getTextThemeProvider';

export const getAppTitle = (): string => {
  return getTextThemeProvider().AppTitle;
};
